import {kGamesImages} from "../../../constants/images";

export default function GamesResultImage({isLost}) {
    // Used in either GamesLooseResultContent or GamesSuccessResultContent
    // to display corresponding emoji

    // BUILD
    return (
        <div className={"w-[120px] min-w-[120px] h-[80px] flex justify-center items-center"}>
            <img className={"object-contain w-full h-full"}
                 alt={"Résultat"}
                 src={isLost ? kGamesImages.looseImage : kGamesImages.successImage} />
        </div>
    );
}